import { FC } from "react";
import { AnalyticsOutlined } from "@mui/icons-material";
import { ResourceDetailsContentCollapsableCard } from "../../../../ResourceDetailsContentCollapsableCard";
import { ResourceDetailsK8SMetricsTabContent } from "@/components/pages/common/resource-details/components/content/metrics-content/ResourceDetailsK8SMetricsTabContent";

export const ResourceDetailsGeneralContentK8SUsage: FC = () => {
  return (
    <ResourceDetailsContentCollapsableCard
      title="Usage"
      Icon={<AnalyticsOutlined fontSize="small" />}
    >
      <ResourceDetailsK8SMetricsTabContent padding={0} />
    </ResourceDetailsContentCollapsableCard>
  );
};
